import styled from 'styled-components'

export default {
	Wrapper: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		gap: 72px;
	`,

	TierWrapper: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;
		justify-content: center;

		& > img {
			height: 18px;
		}
	`,

	Tier: styled.div`
		width: fit-content;
		color: ${({theme, $tier}) => {
			if ($tier === 'CHALLENGER') return theme.color['challenger']
			else if ($tier === 'DIAMOND') return theme.color['diamond']
			else if ($tier === 'PLATINUM') return theme.color['platinum']
			else if ($tier === 'GOLD') return theme.color['gold']
			else if ($tier === 'SILVER') return theme.color['silver']
			else if ($tier === 'BRONZE') return theme.color['bronze']
			else return theme.color['white']
		}};
		${({theme}) => theme.font['medium-bold']};
	`,

	MyInfoDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;
		padding: 56px 24px 16px 24px;
		background-color: ${({theme}) => theme.color['black']};

		& > h2 {
			${({theme}) => theme.font['xlarge-semibold']};
			color: ${({theme}) => theme.color['white']};
		}
	`,
	ProfileDiv: styled.div`
		display: flex;
		align-items: center;
		gap: 12px;
		border-bottom: 1px solid ${({theme}) => theme.color['white']};
		padding-bottom: 16px;

		& > img {
			width: 64px;
			min-width: 64px;
			height: 64px;
			min-height: 64px;
			border-radius: 50%;
			object-fit: cover;
			object-position: center center;
		}

		& > div {
			display: flex;
			flex-direction: column;
			gap: 4px;

			& > p {
				color: ${({theme}) => theme.color['grey3']};
				${({theme}) => theme.font['small-medium']};
			}
		}
	`,
	NameDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;

		& > div {
			display: flex;
			align-items: center;
			gap: 8px;

			& > h2 {
				color: ${({theme}) => theme.color['white']};
				${({theme}) => theme.font['xlarge-bold']};
			}

			& > img {
				height: 18px;
			}
		}

		& > p {
			height: fit-content;
			color: ${({theme}) => theme.color['white']};
			${({theme}) => theme.font['tiny-regular']};
			white-space: nowrap;
		}
	`,
	RecordTable: styled.table`
		width: 100%;
		table-layout: fixed;

		th {
			color: ${({theme}) => theme.color['grey3']};
			${({theme}) => theme.font['small-regular']};
			padding-bottom: 8px;
		}
	`,
	RecordTd: styled.td`
		${({theme}) => theme.font['medium-bold']};
		text-align: center;

		color: ${({theme, $tier}) => {
			if ($tier === 'CHALLENGER') return theme.color['challenger']
			else if ($tier === 'DIAMOND') return theme.color['diamond']
			else if ($tier === 'PLATINUM') return theme.color['platinum']
			else if ($tier === 'GOLD') return theme.color['gold']
			else if ($tier === 'SILVER') return theme.color['silver']
			else if ($tier === 'BRONZE') return theme.color['bronze']
			else return theme.color['white']
		}};
	`,

	QualificationList: styled.div`
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 4px;
		padding-left: 24px;

		& > p {
			color: ${({theme}) => theme.color['white']};
			${({theme}) => theme.font['medium-bold']};
			text-transform: uppercase;
			text-align: left;
		}
	`,

	Content: styled.div`
		display: flex;
		flex-direction: column;
		align-items: end;
		gap: 40px;
		padding: 36px 24px 0 24px;
	`,
	ElementList: styled.div`
		display: flex;
		flex-direction: column;
		gap: 24px;
		align-items: center;

		& > h2 {
			width: 100%;
			color: ${({theme}) => theme.color['grey4']};
			${({theme}) => theme.font['small-semibold']};
		}
	`,
	List: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;

		& > p {
			${({theme}) => theme.font['xsmall-medium']};
			color: ${({theme}) => theme.color['black']};
		}
	`,
	PageElement: styled.button`
		display: flex;
		align-items: center;
		gap: 16px;

		& > p {
			width: 100%;
			text-align: left;
			${({theme}) => theme.font['large-medium']};
		}
	`,
	Icon: styled.img`
		width: 20px;
		min-width: 20px;
		height: 20px;
		object-fit: contain;
	`,
	MoveIcon: styled.img`
		width: 20px;
		height: 12px;
		object-fit: contain;
		object-position: right;
	`,
	EventElement: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
		padding-bottom: 12px;
		border-bottom: 1px solid ${({theme}) => theme.color['grey2']};

		& > div {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 4px;

			& > h2 {
				${({theme}) => theme.font['large-semibold']};
			}

			& > p {
				${({theme}) => theme.font['small-regular']};
				color: ${({theme}) => theme.color['grey4']};
			}
		}

		& > button {
			display: flex;
			align-items: center;
			gap: 4px;

			& > p {
				${({theme}) => theme.font['xsmall-semibold']};
				white-space: nowrap;
			}

			& > img {
				height: 8px;
			}
		}
	`,
	ControlDiv: styled.div`
		display: flex;
		gap: 8px;
	`,
	SupportBtn: styled.button`
		width: fit-content;
		${({theme}) => theme.font['small-regular']};
		padding-bottom: 2px;
		border-bottom: 1px solid ${({theme}) => theme.color['black']};
	`,

	InfoDiv: styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
		padding-bottom: 40px;

		& > h2 {
			${({theme}) => theme.font['medium-bold']};
			margin-bottom: 8px;
		}

		& > p {
			${({theme}) => theme.font['xsmall-semibold']};
			color: ${({theme}) => theme.color['grey3']};

			& > span {
				${({theme}) => theme.font['xsmall-regular']};
				color: ${({theme}) => theme.color['grey3']};
			}
		}
	`,
}
